import React from 'react';

const Sobre = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">
        Sobre a Túlio Bicicletas
      </h1>

      <p className="text-gray-700 leading-relaxed mb-4">
        A <strong>Túlio Bicicletas</strong> nasceu da paixão pelo ciclismo e da missão de oferecer qualidade, segurança e atendimento diferenciado a cada cliente. Com anos de experiência no mercado, conquistamos a confiança de milhares de ciclistas, profissionais e amadores.
      </p>

      <p className="text-gray-700 leading-relaxed mb-4">
        Atuamos com uma linha completa de bicicletas, peças, acessórios e serviços especializados. Nossas lojas físicas estão presentes nas principais regiões da Paraíba e agora você também pode contar com nossa loja online, oferecendo praticidade e confiança em cada pedalada.
      </p>

      <p className="text-gray-700 leading-relaxed mb-4">
        Nosso compromisso é proporcionar a melhor experiência sobre duas rodas. Seja para lazer, esporte ou transporte, estamos aqui para te ajudar a encontrar a bicicleta ideal.
      </p>

      <p className="text-gray-700 leading-relaxed">
        Obrigado por fazer parte da nossa história. Boas pedaladas!
      </p>
    </div>
  );
};

export default Sobre;
